import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M9.219 80.356a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M6.414 99.799a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M100.878 49.354a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M13.055 34.94a1.5 1.5 0 0 1 0 2.12L3.06 47.056a1.5 1.5 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M.94 34.94a1.5 1.5 0 0 1 2.12 0l9.995 9.993a1.5 1.5 0 0 1-2.122 2.122L.94 37.06a1.5 1.5 0 0 1 0-2.122M106.067 49.5a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V51a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M97.5 58.067a1.5 1.5 0 0 1 1.5-1.5h14.134a1.5 1.5 0 0 1 0 3H99a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M20.068 80.923a7.995 7.995 0 0 0 7.995 7.995h54.761c6.063 0 10.978-4.915 10.978-10.978V38.884H20.068z"
    />
    <path
      fill="#0597A3"
      d="M85.807 23.084H28.062a7.994 7.994 0 0 0-7.995 7.994v7.806h73.734v-7.806a7.994 7.994 0 0 0-7.994-7.994"
    />
    <path
      fill="#001A43"
      d="M49 68.592c0-4.47-3.212-7.347-8.182-7.347h-3.636c-2.727 0-2.727-1.2-2.727-1.837s0-1.837 2.727-1.837h7.879c1.503 0 2.727-1.236 2.727-2.755s-1.224-2.755-2.727-2.755h-3.334v-.306C41.727 50.237 40.503 49 39 49s-2.727 1.237-2.727 2.755v.343c-4.449.33-7.273 3.135-7.273 7.31 0 4.47 3.212 7.347 8.182 7.347h3.636c2.727 0 2.727 1.2 2.727 1.837s0 1.837-2.727 1.837H32.94c-1.503 0-2.727 1.236-2.727 2.755s1.224 2.755 2.727 2.755h3.334v.306C36.273 77.763 37.497 79 39 79s2.727-1.237 2.727-2.755v-.343c4.449-.33 7.273-3.135 7.273-7.31"
    />
    <path
      fill="#D8FFFF"
      d="M56.935 94.22a5.267 5.267 0 0 0 5.267 5.267h31.6a5.267 5.267 0 0 0 5.267-5.267v-15.8H56.936z"
    />
    <path
      fill="#0597A3"
      d="M93.801 67.886h-31.6a5.267 5.267 0 0 0-5.267 5.267v5.267h42.133v-5.267a5.267 5.267 0 0 0-5.266-5.267"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M81.018 88.953a2.25 2.25 0 0 1 2.25-2.25h5.267a2.25 2.25 0 0 1 0 4.5h-5.267a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconDigitalPaymentBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDigitalPaymentBrand);
export default Memo;
